import React from "react";
import { Alert, AlertTitle } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useTranslation } from "react-i18next";

/**
 * COYN-1507 §15: shown when the troubleshooting API answers 403 although the
 * frontend gate let the user in (e.g. an inactive or deleted role/action on
 * the backend). Replaces the generic error; no retry is offered.
 */
const TimelineAccessDenied: React.FC = () => {
  const { t } = useTranslation("troubleshooting");
  return (
    <Alert
      severity="warning"
      icon={<LockOutlinedIcon />}
      data-testid="timeline-access-denied"
    >
      <AlertTitle>{t("accessDenied.title")}</AlertTitle>
      {t("accessDenied.hint")}
    </Alert>
  );
};

export default TimelineAccessDenied;
